<!-- QUIZ -->
<div class="container">
<div class="row mt-2">
    <div class="col-12 rounded p-3 ">
        <h3 class="text-center font-weight-bold text-center" [innerHTML]="interaction?.config?.domanda.testo"></h3>
        <div class="mt-2 text-center">
            <img class="img-fluid d-block mx-auto text-center rounded" [src]="interaction?.config?.domanda.immagine" [alt]="interaction?.title" *ngIf="interaction?.config?.domanda.immagine">
        </div>
    </div>
</div>
<div class="row bt-1 mt-3">
    <div  [class]="risposta.immagine ? 'col-md-6 col-6 pt-2' : 'col-12 bg-primary'"  class="  mb-1 p-2 risposta bg-white rounded text-center"
          *ngFor="let risposta of interaction?.config?.risposte; let i = index"
          [class.correctBorder]="(risposta.value && risposta.selected) || (interaction?.completed?.onComplete && risposta.value)"
          [class.wrongBorder]="!risposta.value && risposta.selected">
        <div class="row d-flex align-items-center text-center" (click)="isCorrect(risposta)" [style.opacity]="!interaction?.completed?.onComplete || (interaction?.completed?.onComplete && risposta.value) ? 1 : 0.3">
            <!--<div class="col-2"><span class="answere-number">{{i+1}}</span></div>-->
            <!-- <span class="answere-number" [style.borderColor]="(risposta.value && risposta.selected) ? 'green' : '#fff'" >{{i+1}}</span> -->
            <div class="col-sm-12 col-md-6" *ngIf="risposta.immagine">
                <img class="img-fluid d-block mx-auto rounded" [src]="risposta.immagine" [alt]="risposta.testo" *ngIf="risposta.immagine">
            </div>
            <div [class]="risposta.immagine ? 'col-md-6 col-12 pt-2' : 'col-10 offset-1 bg-secondary p-2 rounded-pill testo'" class="" [innerHTML]="risposta.testo"></div>
        </div>
    </div>
</div>
<!-- END OF QUIZ -->
</div>
